export var ClientType;

(function (ClientType) {
  ClientType[ClientType["contratante"] = 0] = "contratante";
  ClientType[ClientType["asegurado"] = 1] = "asegurado";
  ClientType[ClientType["beneficiario"] = 2] = "beneficiario";
})(ClientType || (ClientType = {}));

export var CLAIM_DOCUMENT_TYPES = [{
  value: "ClaimDocuments::CompanyClaim",
  label: "Denuncia"
}, {
  value: "ClaimDocuments::ClientRecord",
  label: "Antecedente cliente"
}, {
  value: "ClaimDocuments::IncidentImage",
  label: "Fotografías/Imágenes"
}, {
  value: "ClaimDocuments::InspectionsReports",
  label: "Informes/Inspecciones"
}, {
  value: "ClaimDocuments::LiquidationPayment",
  label: "Liquidaciones / pagos"
}, {
  value: "ClaimDocuments::LiquidationReport",
  label: "Informe liquidación"
}, {
  value: "ClaimDocuments::AdditionalDocumentation",
  label: "Documentación adicional"
}, {
  value: "ClaimDocuments::AdjustmentLetter",
  label: "Carta de ajuste"
}, {
  value: "ClaimDocuments::InspectionReport",
  label: "Informe de Inspección"
}, {
  value: "ClaimDocuments::Settlement",
  label: "Finiquitos"
}, {
  value: "ClaimDocuments::SentCorrespondence",
  label: "Correspondencia enviada"
}, {
  value: "ClaimDocuments::ReceivedCorrespondence",
  label: "Correspondencia recibida"
}, {
  value: "ClaimDocuments::UrgentDocuments",
  label: "Documentos urgentes"
}];
export var statusActions = {
  ok: "ok",
  error: "error"
};